var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 29H29",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3585 29V1.3C26.3585 1.13431 26.2241 1 26.0585 1H3.94148C3.77579 1 3.64148 1.13431 3.64148 1.3V28.5172",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.566 28.5172V23.0241C11.566 22.8584 11.7004 22.7241 11.866 22.7241H18.134C18.2996 22.7241 18.434 22.8584 18.434 23.0241V28.5172",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4264 12.5H8.8C8.63431 12.5 8.5 12.6343 8.5 12.8V16.0621C8.5 16.2278 8.63431 16.3621 8.8 16.3621H12.4264C12.5921 16.3621 12.7264 16.2278 12.7264 16.0621V12.8C12.7264 12.6343 12.5921 12.5 12.4264 12.5Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4264 12.5H16.8C16.6343 12.5 16.5 12.6343 16.5 12.8V16.0621C16.5 16.2278 16.6343 16.3621 16.8 16.3621H20.4264C20.5921 16.3621 20.7264 16.2278 20.7264 16.0621V12.8C20.7264 12.6343 20.5921 12.5 20.4264 12.5Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4264 5.34473H8.8C8.63431 5.34473 8.5 5.47904 8.5 5.64473V8.9068C8.5 9.07248 8.63431 9.2068 8.8 9.2068H12.4264C12.5921 9.2068 12.7264 9.07248 12.7264 8.9068V5.64473C12.7264 5.47904 12.5921 5.34473 12.4264 5.34473Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4264 5.34473H16.8C16.6343 5.34473 16.5 5.47904 16.5 5.64473V8.9068C16.5 9.07248 16.6343 9.2068 16.8 9.2068H20.4264C20.5921 9.2068 20.7264 9.07248 20.7264 8.9068V5.64473C20.7264 5.47904 20.5921 5.34473 20.4264 5.34473Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.f0ac26d937e74123eacec289a29097b9.svg";
export { ForwardRef as ReactComponent };